import React from "react"
import PropTypes from "prop-types"
import {
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Grid,
} from "@mui/material"
import { buildNextNumbersPreview } from "./utils/buildNextNumbersPreview"

const NUMERATION_TYPE_DYNAMIC = "dynamic"
const NUMERATION_TYPE_STATIC = "static"

const NumerationBudgetsTab = ({
  selected,
  handleNumerationTypeChange,
  localPrefix1,
  setLocalPrefix1,
  localPrefix2,
  setLocalPrefix2,
  localNextNumber,
  setLocalNextNumber,
}) => (
  <Box>
    <RadioGroup value={selected} onChange={handleNumerationTypeChange}>
      <FormControlLabel
        value={NUMERATION_TYPE_STATIC}
        control={<Radio />}
        label={"Numeración estática"}
      />
      <FormControlLabel
        value={NUMERATION_TYPE_DYNAMIC}
        control={<Radio />}
        label={"Numeración dinámica"}
      />
      <Box>
        <TextField
          label={"Próximos números"}
          value={buildNextNumbersPreview(
            localPrefix1,
            localPrefix2,
            localNextNumber,
          )}
          disabled
          fullWidth
          variant="outlined"
          size="small"
          margin="normal"
          sx={{ mb: 2 }}
        />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              label={"Prefijo 1"}
              value={localPrefix1}
              onChange={e => setLocalPrefix1(e.target.value)}
              onBlur={() => setLocalPrefix1(prev => (prev ?? "").trim())}
              disabled={selected === NUMERATION_TYPE_STATIC}
              fullWidth
              variant="outlined"
              size="small"
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label={"Prefijo 2"}
              value={localPrefix2}
              onChange={e => setLocalPrefix2(e.target.value)}
              onBlur={() => setLocalPrefix2(prev => (prev ?? "").trim())}
              disabled={selected === NUMERATION_TYPE_STATIC}
              fullWidth
              variant="outlined"
              size="small"
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label={"Próximo número"}
              type="number"
              inputProps={{ step: 1, min: 1, pattern: "[0-9]*", maxLength: 15 }}
              value={localNextNumber}
              onChange={e => {
                const val = e.target.value
                if (/^\d{0,15}$/.test(val)) {
                  setLocalNextNumber(val)
                }
              }}
              onBlur={() => {
                setLocalNextNumber(prev => {
                  const v = parseInt((prev ?? "").toString(), 10)
                  const normalized = Number.isFinite(v) && v >= 1 ? v : 1
                  return String(normalized)
                })
              }}
              disabled={selected === NUMERATION_TYPE_STATIC}
              fullWidth
              variant="outlined"
              size="small"
              margin="normal"
            />
          </Grid>
        </Grid>
      </Box>
    </RadioGroup>
  </Box>
)

NumerationBudgetsTab.propTypes = {
  selected: PropTypes.string.isRequired,
  handleNumerationTypeChange: PropTypes.func.isRequired,
  localPrefix1: PropTypes.string.isRequired,
  setLocalPrefix1: PropTypes.func.isRequired,
  localPrefix2: PropTypes.string.isRequired,
  setLocalPrefix2: PropTypes.func.isRequired,
  localNextNumber: PropTypes.string.isRequired,
  setLocalNextNumber: PropTypes.func.isRequired,
}

export default NumerationBudgetsTab
